<template>
	<v-container>
		<v-row><v-col class="col-12"><h2>NALC официальный стандарт для Луизианской Леопардовой собаки катахулы</h2></v-col></v-row>
		<v-row>
			<v-col class="col-12"><h3>ПРОИСХОЖДЕНИЕ И ЦЕЛЬ</h3></v-col>
			<v-col class="col-12">
				Луизианская леопардовая собака катахулы возникла на территории Луизианы, США. Собака используется в качестве пастушьей собаки, собаки для травли, собаки, которая способна лазать по деревьям, собаки-компаньона, и сторожевой собаки.
			</v-col>
		</v-row>
			
		<v-row>
			<v-col class="col-12"><h3>ОБЩИЙ ВИД</h3></v-col>
			<v-col class="col-12">
				Катахула является средней или средне-крупной породой собак. Такая собака должна быть хорошо мускулистой но это не должно мешать ее высокой выносливости и ловкости. 
			</v-col>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ТЕМПЕРАМЕНТ</h3></v-col>
			<v-col class="col-12">
				Катахула является независимой, охранной и территориальной собакой. Она может показать агрессивное поведение. Признаки робости на поводке не следует воспринимать как трусость, присутствует нетерпимость к незнакомцам.
			</v-col>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>РАЗМЕР</h3></v-col>
			<v-col class="col-12">
				Высота в холке у самцов должна быть в пределах (55,8 см - 66,0 см).<br>
				Высота в холке у самок должна быть в пределах (50,8 см - 60,9 см). 
			</v-col>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ШЕРСТЬ И ОКРАС</h3></v-col>
			<p>Длина шерсти должна быть короткой. </p>
			<p>Леопардовый окрас является предпочтительными и могут переходить в голубой леопрад, серый, черный, коричневый, печеночный, красный, белый. Подпал и отметины могут  быть черными, белыми, коричневыми, красными, или смешанными.</p>
			<p>Сплошные цвета (солид окрас) является приемлемым (черный, желтый, красный и шоколад).</p>
			<p><strong class="aboutinfo">Дисквалификация: Длинная шерсть или собаки с нечетким окрасом. </strong></p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ГОЛОВА</h3></v-col>
			<p>Голова должна быть крепко сложенной с хорошо развитыми щеками. </p>
			<p>Череп: Широкий череп с четкой границей перехода ото лба к носу. Умеренной длины. </p>
			<p>Глаза: глаза (стекло) светло-голубые являются предпочтительными, хотя и могут любого цвета или даже комбинированными. Глаза могут быть одного цвета или могут иметь гетерохроимю в одном глазе (трещина). </p>
			<p>Уши: Уши должны быть средней длины и основание уха должно быть на уровне или чуть ниже верхней части головы. Правильные висячие уши, с немного вывернутым наружу  внутренним краем уха, лежащее близко к щеке, являются предпочтительными. "Непринужденные" уши являются приемлемыми. Неисправность: уши которые смотрят в разные стороны (порящие уши) или уши напоминающие уши охотничьих собак.</p>
			<p><strong class="aboutinfo">Дисквалификация: Купированные уши или стоячие уши.  </strong></p>
			<p>Морда: Морда должна быть сильной, глубокой и примерно равна длине верха черепа, измеренного от основания до затылочной кости. Морда должна быть широкой у основания и сужаться к носу при взгляде спереди. </p>
			<p>Прикус: Прикус должен быть сильным ножницеобразный, прямой прикус является приемлемым. Полная дентиция очень желательно; Однако, выбитые зубы не должны быть нарушенными.</p>
			<p><strong class="aboutinfo">Серьезные недочеты: собаки, имеющие либо недокус либо перекус.</strong></p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ШЕЯ И ТУЛОВИЩЕ</h3></v-col>
			<p>Шея: Шея должна быть мускулистой и хорошей длины. </p>
			<p>Туловище: Спина должна быть сильной с хорошо развитой мускулатурой средней длины. </p>
			<p>Грудь должна быть глубокой достигая длины ниже локтя. Грудь должна быть достаточно широкой с хорошо изогнутыми ребрами. Линия груди должно быть подтянут вверх в области набедренной ямки в умеренной степени. </p>
			<p><strong class="aboutinfo">Ошибка: Собаки, которые являются  низкорослыми или слишком крупными.</strong></p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ГРУДНЫЕ КОНЕЧНОСТИ</h3></v-col>
			<p>Длина грудной конечности должна быть 50-60% от общей высоты собаки, измеренная от земли до холки. Плечи должны быть хорошо отведены назад,  плечевые кости достаточной длины. Грудные конечности должны быть сильными и умеренной длины. Хорошо развитые перепонки между пальцами лап. Когти могут присутствовать или могут быть удалены, но если они присутствуют, должны быть равномерным.</p>
			<p><strong class="aboutinfo">Неисправность: Кошачья лапа или енотовидная конечность.</strong></p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ТАЗОВЫЕ КОНЕЧНОСТИ</h3></v-col>
			<p>Круп должен быть средней длины и слегка иметь наклон возле репицы хвоста, который имеет среднее или высокое поднятие. Коленные суставы должны быть хорошо выраженными и углы сочленений и плюсны должны располагаться низко над землей. Плюстна и заплюстна должны быть ровными и не должны смотреть ни внутрь, ни наружу, если смотреть сзади. Серьезные ошибки: Собака- натуральный бобтейл или собака с купированным хвостом. </p>
			<p><strong class="aboutinfo">Дисквалификация: односторонний или двусторонний крипторхизм.</strong></p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ДВИДЖЕНИЕ</h3></v-col>
			<p>Движение должно быть плавным и без усилий, маневренность. Рысь является приемлемым аллюром. </p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>ВАЖНАЯ ПАМЯТКА:</h3></v-col>
			<p>Большинство катахул имеют пятнистый окрас (леопардовый окрас). Некоторые из них имеют от 2 до 5 различных цветов в окрасе, с одним основным цветом шерсти. Другие могут иметь сплошной цвет (называемый солид-твердый окрас), с небольшим количеством белого на груди, морде и/или конечностях.</p>
			<p>Их перепончатые пальцы помогают собакам легко ходить по грязи в заболоченных, а также заснеженных местах. Они отличные пловцы. Катахула продолжает расти до 2-2,5 лет, но как правило начинают работать в возрасте 9-10 мес возрасте, что может привести к выгоранию в раннем возрасте. Так как в этом возрасте они являются еще щенками, которым нужно веселье и забота. Поэтому в элементах дрессировки необходимо помнить о веселых играх, чтобы собака не потеряла интерес к основной деятельности.</p>
			<p>Эта универсальная собака, которая может быть обучена практически для любых целей, от охоты до охраны. Катахула всегда хочет радовать своего владельца. Данное явление с природными инстинктами, дает возможность привлечь внимание щенка и обучать его основным элементами послушания. Катахула, довольно самостоятельная собака и способна развивать свой собственный стиль работы - это важно учитывать при разведении собак, так как данное качество - наследуемое. Они могут работать используя зрение, слух, обоняние, и тем самым являются отличными работниками в полевых испытаниях. Доброе слово и поглаживание по голове будет считаться, как достаточная награда для катахулы.</p>
		</v-row>

		<v-row>
			<v-col class="col-12"><h3>Окрас шерсти и цвет глаз луизианской леопардовой собаки катахулы</h3></v-col>
			<p>Ниже приведены некоторые примеры возможных окрасов шерсти и цвета глаз. Обратите внимание, что это не полный список всех возможных окрасов!</p>
			<p><v-img src="@/img/colors.png" class="img-fluid" /></p>
		</v-row>
	</v-container>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'About',
	components: {
	}
}
</script>
